import Component from '../core/Component'
import Scroll from '../services/Scroll'
import { EVENTS } from '../core/Events'
import EventBus from '../core/EventBus'
import withMedia from '../core/withMedia'

class IntroResizement extends Component {
    constructor(element) {
        super(element, {
            media: 'xlargeUp',
        })

        this.ref = {
            imageLeft: null,
            imageRight: null
        }

        this.state = {
            elementBounding: null,
            startingPoint: null,
            endingPoint: null
        }
    }

    prepare() {
        Scroll.on('scroll', this.handleScroll)
        Scroll.on('resize', this.handleResize)
        this.resize()

        EventBus.on(EVENTS.SWUP_CONTENT_REPLACED, () => {
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 1000)
        })
    }

    // destroy() {
    //     Scroll.off('scroll', this.handleScroll)
    //     Scroll.off('resize', this.handleResize)
    // }

    handleResize = () => {
        this.resize()
    }

    resize = () => {
        this.state.elementBounding = this.element.getBoundingClientRect()
        this.state.startingPoint = this.state.elementBounding.top - window.innerHeight
        this.state.endingPoint = this.state.elementBounding.top + this.state.elementBounding.height
    }

    handleScroll = (event) => {
        if(this.state.startingPoint < event.y && this.state.endingPoint > event.y) {
            const magicValue =  (event.y - this.state.startingPoint) / 18
            this.ref.imageRight.style.width = `calc(100% + ${magicValue}px)`
            this.ref.imageLeft.style.width = `calc(100% - ${magicValue}px)`
            this.ref.imageRight.style.left = `-${magicValue}px`
        }
    }
}

export default withMedia(IntroResizement)